import { api } from './api';
import { selectors } from './selectors';
import { slice } from './slice';

interface IFleetStore {
  actions: typeof slice.actions;
  selectors: typeof selectors;
  api: typeof api;
}

const fleetStore: IFleetStore = {
  actions: slice.actions,
  selectors,
  api,
};

export { fleetStore };
